import { SyncHttpReqConfig, SyncHttpReqResultError, SyncHttpReqResultStatus } from "@fusion-advantage/formrender"
import { AppErrorArgs } from "../errorSlice"
import { FusionError } from "@fusion-advantage/backcompat"
import _ from "lodash"

const ERRMSG_NETWORK = 'You must be online and have a stable connection to perform this action.  Please check your Wi-Fi or cellular connection and try again.  If you are having difficulty, please contact support.'
const ERRMSG_UNAUTHORIZED = 'Please login again to continue using the application.  If you are having difficulty, please contact support.'
const ERRMSG_FORBIDDEN = 'Your permissions do not allow you to perform this function; please contact support.'
const ERRMSG_UNKNOWN = 'Sorry, there was an unknown error; please try again or contact support.'

interface onlineHttpErrorConfig {
	alertOnNetErr?: boolean
	alertOnUnauthorized?: boolean
	alertOnForbidden?: boolean
	debuggerOnUnknown?: boolean
	alertOnUnknown?: boolean
	// what to tell the user when the api deliberately rejects the request (400).
	// only supply this where the rejection is an expected outcome the user can
	// act on; without it a bad request is handled exactly like an unknown error
	badRequestMessage?: string
}

export const onlineHttpError = (
	cfg: SyncHttpReqConfig,
	error: SyncHttpReqResultError,
	{
		alertOnNetErr = true,
		alertOnUnauthorized = true,
		alertOnForbidden = true,
		debuggerOnUnknown = true,
		alertOnUnknown = true,
		badRequestMessage,
	}: onlineHttpErrorConfig
): AppErrorArgs => {
	const cfg2 = _.omit(cfg, 'axInst')
	let fusionError: FusionError = {
		name: 'OnlineHttpError',
		area: `onlineHttpError ${cfg2.url}`,
		// technically not throw safe, but unlikely
		message: `${error.status} ${JSON.stringify(cfg2)}`,
	}
	if(alertOnNetErr && error.status === SyncHttpReqResultStatus.NetworkError) {
		return {
			err: fusionError,
			suppressDebugger: true,
			suppressAlert: false,
			alertMessage: ERRMSG_NETWORK,
			suppressGeneralLog: true,
		}
	} else if(alertOnUnauthorized && error.status === SyncHttpReqResultStatus.Unauthorized) {
		return {
			err: fusionError,
			suppressDebugger: true,
			suppressAlert: false,
			alertMessage: ERRMSG_UNAUTHORIZED,
			suppressGeneralLog: true,
		}
	} else if(alertOnForbidden && error.status === SyncHttpReqResultStatus.Forbidden) {
		return {
			err: fusionError,
			suppressDebugger: true,
			suppressAlert: false,
			alertMessage: ERRMSG_FORBIDDEN,
			suppressGeneralLog: true,
		}
	} else if(badRequestMessage && error.status === SyncHttpReqResultStatus.BadRequest) {
		// an expected rejection the caller can explain; still logged, because
		// the api's own message is the only record of why it was rejected
		return {
			err: {
				...fusionError,
				message: `${error.error?.message} ${fusionError.message}`,
			},
			suppressDebugger: true,
			suppressAlert: false,
			alertMessage: badRequestMessage,
			suppressGeneralLog: false,
		}
	} else {
		return {
			err: {
				...fusionError,
				message: `${error.error?.message} ${fusionError.message}`,
			},
			suppressDebugger: !debuggerOnUnknown,
			suppressAlert: !alertOnUnknown,
			alertMessage: ERRMSG_UNKNOWN,
			suppressGeneralLog: false,
		}
	}
}
